// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"DefaultLayout_breadcrumbs__Ji1oE"};